(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sam-collection-rest"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__samCollFold) return;
    window.__samCollFold = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.sam-coll--in-grid .sam-coll__more');
      if (!btn) return;
      var fold = btn.closest('[data-sam-fold]');
      if (!fold) return;
      var open = fold.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      if (!open) fold.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sam-filter-info"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__samFilterInfo) return;
    window.__samFilterInfo = true;

    var lang = (document.documentElement.lang || 'nl').slice(0, 2);
    var T = {
      nl: { info: 'Uitleg', close: 'Sluiten' },
      de: { info: 'Erklärung', close: 'Schließen' },
      en: { info: 'Explanation', close: 'Close' }
    }[lang] || { info: 'Uitleg', close: 'Sluiten' };

    var ICON =
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.5"/><path d="M10 9v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="10" cy="6.3" r="1" fill="currentColor"/></svg>';

    function norm(s) {
      return (s || '')
        .toLowerCase()
        .replace(/ul\s*94/g, '')
        .replace(/[\s\-‑.·]/g, '');
    }

    function valueMap(tpl) {
      var map = {};
      tpl.content.querySelectorAll('.sam-fi__row').forEach(function (row) {
        var dt = row.querySelector('dt');
        var dd = row.querySelector('dd');
        if (dt && dd) map[norm(dt.textContent)] = dd.textContent.trim();
      });
      return map;
    }

    function optionLabel(li) {
      var input = li.querySelector('input[data-label]');
      if (input) return input.getAttribute('data-label');
      var t = li.querySelector('.checkbox__label-text, label');
      return t ? t.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : '';
    }

    var dialog;
    function getDialog() {
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.className = 'sam-fi-dialog';
      dialog.innerHTML =
        '<div class="sam-fi-dialog__inner"><button type="button" class="sam-fi-dialog__close" aria-label="' +
        T.close +
        '">×</button><div class="sam-fi-dialog__content"></div></div>';
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('.sam-fi-dialog__close')) dialog.close();
      });
      document.body.appendChild(dialog);
      return dialog;
    }

    function openInfo(key) {
      var tpl = document.querySelector('template[data-sam-fi="' + key + '"]');
      if (!tpl) return;
      var d = getDialog();
      var c = d.querySelector('.sam-fi-dialog__content');
      c.innerHTML = '';
      c.appendChild(tpl.content.cloneNode(true));
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    }

    function enhance() {
      var seen = {};
      document.querySelectorAll('template[data-sam-fi]').forEach(function (tpl) {
        var key = tpl.getAttribute('data-sam-fi');
        if (seen[key]) return;
        seen[key] = true;
        var label = tpl.getAttribute('data-sam-fi-label') || '';
        var map = valueMap(tpl);
        var hasValues = Object.keys(map).length > 0;

        document
          .querySelectorAll('[data-filter-param-name="' + key + '"]')
          .forEach(function (acc) {
            var summaryLabel = acc.querySelector('.facets__summary .facets__label');
            if (summaryLabel && !summaryLabel.querySelector('.sam-fi__btn')) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'sam-fi__btn';
              b.setAttribute('data-sam-fi-open', key);
              b.setAttribute('aria-label', T.info + ': ' + label);
              b.setAttribute('aria-haspopup', 'dialog');
              b.innerHTML = ICON;
              summaryLabel.appendChild(b);
            }
            if (!hasValues) return;
            acc.querySelectorAll('.facets__inputs-list-item').forEach(function (li) {
              if (li.querySelector('.sam-fi__sub, .facets__pill-wrapper, .variant-option')) return;
              var desc = map[norm(optionLabel(li))];
              if (!desc) return;
              var s = document.createElement('span');
              s.className = 'sam-fi__sub';
              s.textContent = desc;
              li.appendChild(s);
            });
          });
      });
    }

    // Klik op de ⓘ mag het filter niet open/dicht klappen: onderscheppen vóór <summary>.
    function swallow(e) {
      var b = e.target.closest && e.target.closest('.sam-fi__btn');
      if (!b) return null;
      e.preventDefault();
      e.stopPropagation();
      return b;
    }
    document.addEventListener(
      'click',
      function (e) {
        var b = swallow(e);
        if (b) openInfo(b.getAttribute('data-sam-fi-open'));
      },
      true
    );
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var b = swallow(e);
        if (b) openInfo(b.getAttribute('data-sam-fi-open'));
      },
      true
    );
    ['pointerdown', 'mousedown'].forEach(function (t) {
      document.addEventListener(
        t,
        function (e) {
          if (e.target.closest && e.target.closest('.sam-fi__btn')) e.stopPropagation();
        },
        true
      );
    });

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        enhance();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
    else enhance();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
